// extracted by mini-css-extract-plugin
export default {"wrapper":"start-page_wrapper__flo7s"};